import { useCallback } from 'react';
import { useModal } from '~/modal/useModal.hook';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { useSplitPanelState } from '~/store/userData/settings/splitPanel/useSplitPanelState';
import { useBoundaryGroupsChartOptions } from '../chartEditor/useBoundaryGroupsChartOptions';
import { MapPageSplitScreenTab } from '../mapPageSplitScreen.types';

export const useAddNewChart = () => {
  const mapId = useMapIdSelector();
  const boundaryGroupOptions = useBoundaryGroupsChartOptions();
  const { openModal: openAddNewChart } = useModal('ChartsCreate');
  const { getIsTabActive, onTabChange } = useSplitPanelState(mapId);

  const allowAddingCharts = boundaryGroupOptions.length > 0;

  const openChartsPanel = useCallback(() => {
    if (!mapId || getIsTabActive(MapPageSplitScreenTab.Chart)) {
      return;
    }
    onTabChange(MapPageSplitScreenTab.Chart);
  }, [mapId, getIsTabActive, onTabChange]);

  const handleAddNewChartForBoundaryGroup = useCallback((boundaryGroupId: number) => {
    openAddNewChart({
      boundaryGroupId,
    });
    openChartsPanel();
  }, [openAddNewChart, openChartsPanel]);

  const handleAddNewChart = useCallback(() => {
    openAddNewChart({});
    openChartsPanel();
  }, [openAddNewChart, openChartsPanel]);

  return {
    onAddNewChartForBoundaryGroup: handleAddNewChartForBoundaryGroup,
    onAddNewChart: allowAddingCharts ? handleAddNewChart : undefined,
  };
};
